import React from 'react';

import { useState } from 'react';

import helloworld from './helloWorld.css'

function HelloWorld(props){

    const [txt,setTxt]=useState("")

    const changeText=(s)=>{
        setTxt(s) 
    }

    const say=()=>{
        props.onShow(txt)
    }
    return (
        <div className="myDiv">
            <p>{props.name}</p>
            <input onChange={(e)=>changeText(e.target.value)}></input>
            {/*<button onClick={()=>say()}>Say Hello</button>*/}
            <button onClick={()=>props.onShow(txt)}>Say Hello</button>
        </div>
    )
}

export default HelloWorld;